module.exports = __webpack_public_path__ + "static/media/maestro-dark.0d91ff8f.svg";